// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Documentation from './pages/Documentation';
import PHP from './languages/PHP';
import JavaScript from './languages/JavaScript';
import Python from './languages/Python';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/documentation">Documentation</Link>
            </li>
            
          </ul>
        </nav>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/languages/PHP" element={<PHP />} />
          <Route path="/languages/JavaScript" element={<JavaScript />} />
          <Route path="/languages/Python" element={<Python />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;